import moment from 'moment';

export const nextPageParam = (lastPage: any): number | undefined => {
  const { currentPage, data } = lastPage || {};
  if (currentPage < data?.totalPages) {
    return currentPage + 1;
  }
  return undefined;
};

export const dateTimeFormatForDI = (value: any) => {
  if (!value) return '';
  return moment(value).format("Do MMMM 'YY [at] h:mm a");
};

function parseRangeMinMax(range: any): { min: number; max: number } | null {
  if (range == null) return null;
  if (typeof range === 'object' && range.min != null && range.max != null) {
    const min = Number(range.min);
    const max = Number(range.max);
    if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
    return { min, max };
  }
  if (typeof range === 'string') {
    const match = range.match(/(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)/);
    if (match) {
      const min = Number(match[1]);
      const max = Number(match[2]);
      if (Number.isFinite(min) && Number.isFinite(max)) return { min, max };
    }
  }
  return null;
}

/** Format acceptance/optimal range for display e.g. "0 - 50". */
export function formatRange(range: unknown): string {
  if (range == null) return '-';
  if (typeof range === 'string') return range;
  if (typeof range === 'object' && range !== null && 'min' in range && 'max' in range) {
    const { min, max } = range as { min: unknown; max: unknown };
    if (min != null && max != null) return `${min} - ${max}`;
  }
  return '-';
}

/** Returns 'valid' (within recommended), 'acceptable' (within acceptable, outside recommended), 'outOfRange', or null (no ranges / empty input). */
export function getNumericValidationState(row: any): 'valid' | 'acceptable' | 'outOfRange' | null {
  if (row?.dataType !== 'number') return null;
  const acceptance = parseRangeMinMax(row?.acceptanceRange);
  const optimal = parseRangeMinMax(row?.optimalRange);
  const raw = row?.inputValue;
  if (raw === '' || raw === undefined || raw === null) return null;
  const value = Number(raw);
  if (!Number.isFinite(value)) return null;
  const acc = acceptance ?? optimal;
  if (!acc) return null;
  const opt = optimal ?? acc;
  if (value < acc.min || value > acc.max) return 'outOfRange';
  if (value >= opt.min && value <= opt.max) return 'valid';
  return 'acceptable';
}


export function buildSingleEntryFormData(params: {
  sensorId: string;
  plantId: string;
  recordId?: string | null;
  value: any;
  calculatedAt?: number | string | null;
  file?: File | null;
}): FormData {
  const { sensorId, plantId, recordId, value, calculatedAt, file } = params;
  const fd = new FormData();

  if (file && sensorId) {
    fd.append(`file_${sensorId}`, file);
  }

  fd.append(
    'entries',
    JSON.stringify([
      {
        sensorId,
        value,
        plantId,
        ...(recordId != null ? { recordId } : {}),
        ...(calculatedAt != null ? { calculatedAt } : {}),
      },
    ])
  );

  return fd;
}